import { render } from "./customer.vue?vue&type=template&id=39a23592"
import script from "./customer.vue?vue&type=script&lang=ts"
export * from "./customer.vue?vue&type=script&lang=ts"
script.render = render

export default script